import {useEffect, useState} from "react";
import axios from "axios";
import {API} from "../../../helpers/constants";
import {useTranslation} from "react-i18next";
import {ALERTS} from "../../../locales/components/namespaces";
import useUserData from "../../../hooks/user/useUserData";
import {enqueueSnackbar} from "notistack";
import {handleAxiosErrors, logoutUnauthorizedUser} from "../../../helpers/errorHandling";
import useUserAction from "../../../hooks/user/useUserAction";

const useLoanOrigin = () => {
    const {t} = useTranslation(ALERTS)
    const {token, isLoggedIn} = useUserData()
    const {userLogout} = useUserAction()
    const [loading, setLoading] = useState(false)
    const [originLoan, setOriginLoan] = useState([])
    const [updateOriginLoan, setUpdateOriginLoan] = useState(false)

    useEffect(() => {
        setLoading(true)
        axios({
            method: 'get',
            headers: {'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`},
            url: `${API}/loan/origin/list`,
        }).then((response) => {
            setOriginLoan(response.data)
            setLoading(false)

        }).catch(error => {
            setLoading(false)
            enqueueSnackbar(handleAxiosErrors(error, t('Failed to get origins list.'), {
                    variant: 'error'
                }
            ))
            logoutUnauthorizedUser(error, isLoggedIn, userLogout)
        })
    }, [updateOriginLoan])

    return {
        loading,
        originLoan
    }
}

export default useLoanOrigin
